import Router from "./router";
import FloatingContactButtons from "./components/homePage/FloatingContactButtons";
import FloatingSocialBar from "./components/common/FloatingSocialBar";
import MobileAppPrompt from "./components/common/MobileAppPrompt";
import ErrorBoundary from "./components/common/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <Router />
      <FloatingSocialBar />
      <FloatingContactButtons />
      <MobileAppPrompt />
    </ErrorBoundary>
  );
}

export default App;
